import { render, staticRenderFns } from "./oemConsultDetail.vue?vue&type=template&id=1b6ff571&scoped=true"
import script from "./oemConsultDetail.vue?vue&type=script&lang=js"
export * from "./oemConsultDetail.vue?vue&type=script&lang=js"
import style0 from "./oemConsultDetail.vue?vue&type=style&index=0&id=1b6ff571&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ff571",
  null
  
)

export default component.exports